import script from "./EmployeeData.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeData.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeData.vue?vue&type=style&index=0&id=0cd447b2&scoped=true&lang=css"

import exportComponent from "../../../../../ss/CO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd447b2"]])

export default __exports__